export interface IPlayerDiscardMotionInput {
  readonly discardedTileId: number;
  readonly drawnTileId?: number;
}

export interface IPlayerHandReflowInput {
  readonly displayedTileIds: readonly number[];
  readonly discardedTileId: number;
  readonly finalTileIds: readonly number[];
}

/** 只有打出原本手牌時才需要補位；直接打出分離的摸進牌不動其餘手牌。 */
export const shouldCollapsePlayerHandGap = ({
  discardedTileId,
  drawnTileId,
}: IPlayerDiscardMotionInput): boolean =>
  drawnTileId === undefined || discardedTileId !== drawnTileId;

/**
 * 把目前畫面上的每張牌直接對應到出牌後的最終 slot。
 *
 * 不產生「先補打出牌的缺口、再挪出摸進牌插槽」的中間狀態；呼叫端可讓整份 plan
 * 在同一段 tween 同步完成。打出的牌與不在最終手牌中的殘留 sprite 都會被排除。
 */
export const buildPlayerHandReflowPlan = ({
  displayedTileIds,
  discardedTileId,
  finalTileIds,
}: IPlayerHandReflowInput) =>
  displayedTileIds.flatMap((tileId) => {
    if (tileId === discardedTileId) return [];
    const targetIndex = finalTileIds.indexOf(tileId);
    return targetIndex < 0 ? [] : [{ tileId, targetIndex }];
  });
